/**
 * Environment utility functions for determining application behavior
 * based on the current deployment environment.
 */

/**
 * Get the current stage/environment from Vite environment variables
 * @returns The current stage (testing, staging, production) or 'development' as fallback
 */
function getCurrentStage(): string {
  return import.meta.env.VITE_STAGE ?? 'development';
}

/**
 * Determines if the BRZ Finance switch should be editable based on the current environment.
 * The switch is only editable in testing and staging environments.
 * In production, it should be read-only to prevent accidental changes.
 *
 * @returns true if the switch should be editable, false if it should be read-only
 */
export function isBrzFinanceSwitchEditable(): boolean {
  const stage = getCurrentStage();

  // Allow editing in testing and staging environments
  // Disallow editing in production
  return stage === 'testing' || stage === 'staging' || stage === 'development';
}

/**
 * Checks if the current environment is production
 * @returns true if in production environment
 */
export function isProductionEnvironment(): boolean {
  return getCurrentStage() === 'production';
}
